import { DataAPIService } from './AxiosAPIService';
import {
  AlertsResponse,
  AlertTypesResponse,
  AlertsAggregationResponse,
  AlertRisksResponse,
  AlertByDaysResponse,
  AlertsByDriverIdResponse,
  AlertDetails,
  AlertsHeatmapResponse,
  PostRequestVideo,
  AlertDeleteRequest,
  AlertValidationRequest,
} from '../types/Alerts';
import { getSimpleEqQuery } from '../../utils/queryFilters';

const onlyValidAlertsQuery = getSimpleEqQuery('isValid', 'true', 15);

export const getAlerts = async (fleetId: string, query: string): Promise<AlertsResponse> => {
  const { data } = await DataAPIService.api.get<AlertsResponse>(`/${fleetId}/alerts${query}${onlyValidAlertsQuery}`);
  return data;
};

export const getAlertsWithInvalid = async (fleetId: string, query: string): Promise<AlertsResponse> => {
  const { data } = await DataAPIService.api.get<AlertsResponse>(`/${fleetId}/alerts${query}`);
  return data;
};

export const getAlertsAggregation = async (fleetId: string, query: string): Promise<AlertsAggregationResponse> => {
  const { data } = await DataAPIService.api.get<AlertsAggregationResponse>(`/${fleetId}/alerts/aggregation${query}${onlyValidAlertsQuery}`);
  return data;
};

export const getAlertById = async (id: string, fleetId: string): Promise<AlertDetails> => {
  const { data } = await DataAPIService.api.get<AlertDetails>(`/${fleetId}/alerts/${id}`);
  return data;
};

export const deleteAlertById = async (payload: AlertDeleteRequest): Promise<AlertDetails> => {
  const { alertId, fleetId } = payload;
  const { data } = await DataAPIService.api
    .delete<AlertDetails>(`/${fleetId}/alerts/${alertId}`);
  return data;
};

export const patchAlertValidation = async (payload: AlertValidationRequest): Promise<AlertDetails> => {
  const {
    fleetId, alertId, isValid,
  } = payload;

  const { data } = await DataAPIService.api
    .patch<AlertDetails>(`/${fleetId}/alerts/${alertId}/valid`, {
    isValid,
  })
    .catch((e) => Promise.reject(e.response.data));
  return data;
};

export const getAlertTypes = async (fleetId: string, query?: string): Promise<AlertTypesResponse> => {
  const { data } = await DataAPIService.api.get<AlertTypesResponse>(`/${fleetId}/alerts/aggregation/sensor${query}${onlyValidAlertsQuery}`);
  return data;
};

export const getAlertRisks = async (fleetId: string, query?: string): Promise<AlertRisksResponse> => {
  const { data } = await DataAPIService.api.get<AlertRisksResponse>(`/${fleetId}/alerts/aggregation/risk${query}${onlyValidAlertsQuery}`);
  return data;
};

export const getAlertsByDays = async (fleetId: string, query = ''): Promise<AlertByDaysResponse> => {
  const { data } = await DataAPIService.api.get<AlertByDaysResponse>(`/${fleetId}/alerts/aggregation/days${query}${onlyValidAlertsQuery}`);
  return data;
};

export const getAlertsHeatmap = async (fleetId: string, query?: string): Promise<AlertsHeatmapResponse> => {
  const { data } = await DataAPIService.api.get<AlertsHeatmapResponse>(`/${fleetId}/heatmap${query}`);
  return data;
};

export const postRequestAlertVideo = async (payload: PostRequestVideo): Promise<AlertDetails> => {
  const {
    fleetId, deviceId, from, to, alertId, cameraIds,
  } = payload;

  const { data } = await DataAPIService.api
    .post<AlertDetails>(`/${fleetId}/devices/${deviceId}/alerts/request-video`, {
    from,
    to,
    alertId,
    cameraIds,
  })
    .catch((e) => Promise.reject(e.response.data));
  return data;
};

export const getAlertsByDriverId = async (
  driverId: string,
  fleetId: string,
  query = '',
): Promise<AlertsByDriverIdResponse> => {
  const { data } = await DataAPIService.api
    .get<AlertsByDriverIdResponse>(`/${fleetId}/drivers/${driverId}/alerts${query}${onlyValidAlertsQuery}`);
  return data;
};
